import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/EVENT-MODAL';

export const {action: showAddNewEventModal} = createAction(`${domain}/SHOW`, eventId => ({eventId}));

export const {action: hideNewEventModal} = createAction(`${domain}/HIDE`);

export const {
    action: initialFetch,
    success: initialFetchSuccess,
    failed: initialFetchFailed,
} = createAction(`${domain}/INITIAL-FETCH`, eventId => ({eventId}));

export const {
    action: updateRecipients,
    success: updateRecipientsSuccess,
    failed: updateRecipientsFailed,
} = createAction(`${domain}/UPDATE-RECIPIENTS`, institutionId => ({institutionId}));

export const {
    action: createEvent,
    success: createEventSuccess,
    failed: createEventFailed,
} = createAction(`${domain}/CREATE-EVENT`, event => ({event}));

export const {
    action: updateEvent,
    success: updateEventSuccess,
    failed: updateEventFailed,
} = createAction(`${domain}/UPDATE-EVENT`, event => ({event}));
